import React, { Suspense } from 'react';
import VLoading from '../vkyc/v-loading';

const createLazy = (factory: () => Promise<{ default: React.ComponentType<{}> }>) => {
  const Component = React.lazy(factory);
  const LazyLoad = () => {
    return (
      <Suspense fallback={<VLoading show />}>
        <Component />
      </Suspense>
    );
  };
  return LazyLoad;

  // TODO: for better offline handling
  // if (navigator.onLine) {
  //   const Component = React.lazy(factory);
  //   const LazyLoad = () => {
  //     return (
  //       <Suspense fallback={<VLoading show />}>
  //         <Component />
  //       </Suspense>
  //     );
  //   };
  //   return LazyLoad;
  // } else {
  //   const LazyLoad = () => {
  //     return <Suspense fallback={<VLoading show />}>Network Disconnect</Suspense>;
  //   };
  //   return LazyLoad;
  // }
};

export default createLazy;
